import { AfterViewChecked, Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mb-setting-component-template',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <!-- special case: consent settings page -->
    <div
      class="uc-embed"
      uc-embedding-type="category"
      data-language="auto"
      uc-show-toggle="true"
      uc-styling="true"
    ></div>

    <style>
      .uc-embed * {
        font-family: var(--wb-font-text);
      }

      h2.uc-embed-list-headline {
        font-family: var(--wb-font-title);
        font-weight: 400;
        font-size: 2.125rem;
      }

      /* ggf. weitere lokale CSS-Definitionen müssen Website-spezifisch noch ergänzt werden, um das visuelle Erscheinungsbild des folgenden Screenshots zu erreichen*/
    </style>
  `,
})
export class SettingComponent implements AfterViewChecked {
  ngAfterViewChecked(): void {
    this.initializeUserCentrics();
  }
  private initializeUserCentrics(): void {
    if (window.UC_UI) {
      this.handleUserCentricsReady();
      window.UC_UI.restartEmbeddings();
    } else {
      window.addEventListener('usercentrics-ready', this.handleUserCentricsReady.bind(this));
    }
  }

  private handleUserCentricsReady(): void {
    window.removeEventListener('usercentrics-ready', this.handleUserCentricsReady.bind(this));
    if (!window.UC_UI) return;
    window.UC_UI.restartEmbeddings();
  }
}
